import PreviewPage from './PreviewPage';

export default PreviewPage;
